import { render, staticRenderFns } from "./questionbankAdd.vue?vue&type=template&id=cb0dadb8&scoped=true"
import script from "./questionbankAdd.vue?vue&type=script&lang=js"
export * from "./questionbankAdd.vue?vue&type=script&lang=js"
import style0 from "./questionbankAdd.vue?vue&type=style&index=0&id=cb0dadb8&prod&lang=less"
import style1 from "./questionbankAdd.vue?vue&type=style&index=1&id=cb0dadb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0dadb8",
  null
  
)

export default component.exports